import { useEffect } from "react"
import { useIntersectionObserver } from "./useIntersectionObserver"
import { ThemeColor } from "@punks/ui-core"
import { atom, useAtomValue, useSetAtom } from 'jotai'

const menuAtom = atom<{
  color: ThemeColor | undefined
}>({
  color: undefined
})

export const usePageMenuLayout = () => useAtomValue(menuAtom)

export const usePageMenuPainter = (ref: any, color?: ThemeColor) => {
  const updateMenuLayout = useSetAtom(menuAtom)

  const { isIntersecting } = useIntersectionObserver(ref, {
    rootMargin: "0px 0px -100%",
  })

  useEffect(() => {
    if (isIntersecting && color) {
      updateMenuLayout({
        color
      })
    }
  }, [isIntersecting, color])
}
